class CacheManager {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private cache: Map<string, any> = new Map()

  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor() {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get(key: string): any {
    return this.cache.get(key)
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  set(key: string, value: any, ttl = 60): void {
    this.cache.set(key, value)
    setTimeout(() => this.cache.delete(key), ttl * 1000)
  }

  delete(key: string): void {
    this.cache.delete(key)
  }

  clear(): void {
    this.cache.clear()
  }
}

const cacheManager = new CacheManager()
export default cacheManager
